import React from 'react'
import { Link } from 'react-router-dom'
import './SingleAssetItem.css'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';

const SingleAssetItem = ({ title, assetItemPath, assetThumb, assetAlt, price, priceCoin, likeCounter, buttonName, buttonNamePath, artistUsername, artistUsernamePath, ownerUsername, ownerUsernamePath }) => {
    return (
        <li className="singleAssetItem">
            <Link to={assetItemPath}><img src={assetThumb} alt={title} className="AssetItemImg"/></Link>
            <span className="singleAssetItemData">
                <span className="assetDataTop">
                    <h1 className="assetHeading"><Link to={assetItemPath}>{ title }</Link></h1>
                    <h4 className="priceArea">
                        {price} {priceCoin} <Link to={buttonNamePath} className="btn AssetsActionBtn">{buttonName}</Link>
                    </h4>
                </span>
                <hr/>
                <span className="assetDataBottom">
                    <div className="left">
                        <h4 className="assetArtist">Artist: <Link to={artistUsernamePath}>{ artistUsername }</Link></h4>
                        <h4 className="assetArtist">Owner: <Link to={ownerUsernamePath}>{ ownerUsername }</Link></h4>
                    </div>
                    <div className="right">
                        <span className="CollEData"><FavoriteBorderIcon /> {likeCounter}</span>
                    </div>
                </span>
            </span>
        </li>
    )
}

export default SingleAssetItem
